module.exports = __webpack_public_path__ + "static/F5_bg_02-e3a8343a5d77f4669ac29c833a42b431.png";